import { MdDone, MdDoneAll } from 'react-icons/md';
import { IoTimeOutline, IoAlertCircleOutline } from 'react-icons/io5';
import { useChatContext, useMessageContext } from 'stream-chat-react';

export const CustomMessageStatus = () => {
  const { message, readBy = [] } = useMessageContext();
  const { client } = useChatContext();

  const isMine = message.user?.id === client.userID;
  if (!isMine) return null;

  const readBySomeoneElse = readBy.some((u) => u.id !== client.userID);

  const cls = 'inline-flex ml-1';

  switch (message.status) {
    case 'sending':
      return <IoTimeOutline size={14} className={`${cls} text-base-30`} />;
    case 'failed':
      return <IoAlertCircleOutline size={14} className={`${cls} text-danger-50`} />;
    case 'sent':
      return <MdDone size={14} className={`${cls} text-base-30`} />;
    case 'received':
    default:
      return <MdDoneAll size={14} className={`${cls} ${readBySomeoneElse ? 'text-success-60' : 'text-base-30'}`} />;
  }
};
